export default function HonorsSection() {
  return (
    <section className="py-24 px-6 bg-gradient-to-br from-amber-50 to-yellow-50">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <div className="inline-flex items-center gap-3 bg-amber-100 px-6 py-3 rounded-full mb-8">
              <i className="ri-trophy-line text-2xl text-amber-600"></i>
              <span className="text-lg font-semibold text-amber-700">Recognition & Excellence</span>
            </div>

            <h2 className="text-5xl md:text-6xl font-bold mb-6 text-gray-900">
              Honors &<br />Recognition
            </h2>

            <p className="text-xl text-gray-600 leading-relaxed mb-10">
              Three decades of dedication to mathematics education, recognized by the highest authorities in New York City public education.
            </p>

            {/* Achievements */}
            <div className="space-y-8">
              <div className="flex items-start gap-6">
                <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-gradient-to-br from-amber-500 to-orange-600 text-white flex-shrink-0">
                  <i className="ri-medal-line text-3xl"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">
                    Chancellor's Honor Award
                  </h3>
                  <p className="text-lg text-gray-600 leading-relaxed">
                    Publicly praised and honored for excellence in teaching mathematics in NYC Public Schools. This prestigious recognition was made for phenomenal quality of teaching, exceptional dedication and outstanding results in student achievement.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-6">
                <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-gradient-to-br from-emerald-500 to-teal-600 text-white flex-shrink-0">
                  <i className="ri-time-line text-3xl"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">
                    30+ Years of Teaching Excellence
                  </h3>
                  <p className="text-lg text-gray-600 leading-relaxed">
                    Over three decades of experience teaching mathematics, and formerly a Mathematics Teacher at NYC Public High Schools. Thousands of students have benefited from proven teaching methods and personalized instruction
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-6">
                <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-gradient-to-br from-blue-500 to-indigo-600 text-white flex-shrink-0">
                  <i className="ri-user-star-line text-3xl"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">
                    Master Educator Status
                  </h3>
                  <p className="text-lg text-gray-600 leading-relaxed">
                    Recognized as a master educator with expertise in curriculum development, standardized test preparation, and innovative teaching methodologies that make complex concepts accessible to all students.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <div className="w-full h-[700px]">
                <img
                  src="https://static.readdy.ai/image/14fde9ba81a9738a8aa28fb63948ba18/d22023c9dab20247f6bfda9098b0a597.jpeg"
                  alt="Chancellor's Honor Award"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
              
              {/* Overlay Text */}
              <div className="absolute bottom-0 left-0 right-0 p-10 text-white">
                <h4 className="text-3xl font-bold mb-3">Excellence in Education</h4>
                <p className="text-lg leading-relaxed">
                  Committed to making mathematics accessible and enjoyable for every student
                </p>
              </div>
            </div>

            {/* Floating Stats */}
            <div className="absolute -top-8 -left-8 bg-white rounded-2xl shadow-2xl p-6">
              <div className="text-center">
                <p className="text-4xl font-bold text-amber-600 mb-2">5,000+</p>
                <p className="text-sm text-gray-600">Students Taught</p>
              </div>
            </div>

            <div className="absolute -bottom-8 -right-8 bg-white rounded-2xl shadow-2xl p-6">
              <div className="text-center">
                <p className="text-4xl font-bold text-emerald-600 mb-2">95%</p>
                <p className="text-sm text-gray-600">Success Rate</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
